import { ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, IconButton, Popover, Typography } from "@mui/material";

const SMALL_FIELD_HEIGHT = 40;
const MIN_TARGET_SIZE = 24;

interface Props {
  fieldLabel: string;
  text?: string;
  children?: ReactNode;
  dense?: boolean;
}

export function FieldInfo({ fieldLabel, text, children, dense }: Props) {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton
        color="info"
        aria-label={t("common.additionalInfo.showFor", { field: fieldLabel })}
        aria-expanded={open}
        onClick={(event) => setAnchorEl(open ? null : event.currentTarget)}
        sx={
          dense === true
            ? { p: 0, width: MIN_TARGET_SIZE, height: MIN_TARGET_SIZE }
            : { width: SMALL_FIELD_HEIGHT, height: SMALL_FIELD_HEIGHT }
        }
      >
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box sx={{ p: 2, maxWidth: 360 }}>
          {children ?? (
            <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
              {text}
            </Typography>
          )}
        </Box>
      </Popover>
    </>
  );
}
